export default "__VITE_ASSET__DZHHnG7E__"